import { Router } from '@angular/router';
import { CARD_PAYMENT_PATHS, CHECKOUT_PATHS, MERCHANT_MENU_CATEGORY_PATHS, REOPEN_TABLE_ORDERS_PATHS, SALE_UNIT_CART_PATHS } from '@up/data';
/**
 * Utility to check if on `/orders`  Reopen-Table path.
 * @returns True when `/orders` is in path.
 */
export const isReopenTableRoute = (router: Router) => () =>
  router.url.split('/').some((u) => REOPEN_TABLE_ORDERS_PATHS.includes(u));

export const isMenuCategoryRoute = (router: Router) => () =>
  router.url.split('/').some((u) => MERCHANT_MENU_CATEGORY_PATHS.includes(u));

export const isSaleUnitCartRoute = (router: Router) => () =>
  router.url.split('/').some((u) => SALE_UNIT_CART_PATHS.includes(u));

export const isCheckoutRoute = (router: Router) => () =>
  router.url.split('/').some((u) => CHECKOUT_PATHS.includes(u));

export const isCardPaymentRoute = (router: Router) => () =>
  router.url.split('/').some((u) => CARD_PAYMENT_PATHS.includes(u));

export const isTableManagerRoomsRoute = (router: Router) => () =>
  router.url.endsWith('/rooms');